import { z } from 'zod';

import { type ActiveCompanyContextDto } from './active-company-context.dto.js';
import { CompanySchema } from '../tenancy/company.schema.js';

export const ActiveCompanyContextSchema: z.ZodType<ActiveCompanyContextDto> = z.object({
  company: CompanySchema,
  membershipId: z.uuid(),
  roles: z.array(z.uuid()).optional(),
  permissions: z.array(z.string().trim()),
  enabledFeatures: z.array(z.string().trim()),
  entitlementRevision: z.number().int().min(0).optional(),
});
